<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <menu-layout v-if="$route.meta.showNavMenu">
      <router-view/>
    </menu-layout>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>

<script>
import logo from './assets/logo.png'
import tenant from './apis/tenant'
import apis from './apis/column'
import home from './apis/home'
import { mapGetters } from 'vuex'
import { setTenantId } from '@/utils/auth'
export default {
  name: 'App',
  data () {
    return {logo}
  },
  computed: {
    ...mapGetters(['columnItemParent', 'isMemberUnit'])
  },
  created () {
    this.$nextTick(() => {
      this.getTenant()
    })

    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    // 后期可以做成动态图标
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    // link.href = this.logo
    document.getElementsByTagName('head')[0].appendChild(link)
    if (this.columnItemParent) {
      this.$store.commit('SET_ACTIVEINDEX', this.columnItemParent.id)
    }
    this.$nextTick(() => { // 禁用右键
      // eslint-disable-next-line no-new-func
      document.oncontextmenu = new Function('event.returnValue=false')// 禁用选择
      // eslint-disable-next-line no-new-func
      document.onselectstart = new Function('event.returnValue=false')// 禁止f12
      // eslint-disable-next-line no-new-func
      document.οnkeydοwn = new Function('event.returnValue=false')
    })// 上面的禁止f12那段代码没有生效，但是加了下面这段就能生效。
    document.onkeydown = function (e) {
      if (e && e.keyCode === 123) {
        e.returnValue = false
        e.keyCode = 0
        return false
      }
      // 打印
      // if (e && e.keyCode === 80) {
      //   e.returnValue = false
      //   e.keyCode = 0
      //   return false
      // }
      // 下载
      // if (e && e.keyCode === 83) {
      //   e.returnValue = false
      //   e.keyCode = 0
      //   return false
      // }
      if (e && e.keyCode === 17) {
        e.returnValue = false
        e.keyCode = 0
        return false
      }
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getTenant()
    })
  },
  methods: {
    async getTenant () {
      await tenant.getTenant().then(res => {
        this.$store.commit('SET_TENANT', res)
        localStorage.setItem('tenantId', res.id)
        setTenantId(res.id)
        this.getColumnTreeList()
        this.getWebsit()
      })
    },
    async getColumnTreeList () {
      await apis.listColumnTree().then(res => {
        console.log(this.isMemberUnit)
        if (this.isMemberUnit) {
          console.log(res)
          this.$store.commit('SET_COLUMNTREELIST', res)
        } else {
          var arry = res.filter(e => e.columnCode !== 'graph')
          console.log(arry)
          this.$store.commit('SET_COLUMNTREELIST', arry)
        }
      })
    },
    async getWebsit () {
      await home.getWebsit().then(res => {
        this.$store.commit('SET_BANNER', res.bannerPath)
        this.$store.commit('SET_WEBSIT', res)
        this.$store.commit('SET_SITEINTRO', res.siteIntro)
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 微软雅黑, Tahoma, Helvetica, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //background: linear-gradient(360deg, rgba(255,255,255,0) 0%, rgba(182,220,255,0.14) 19%, rgba(103,183,255,0.3) 43%, rgba(46,157,255,0.41) 66%, rgba(12,140,255,0.47) 85%, rgba(0,135,255,0.5) 99%);

  min-width: 1255px;
  /*background: url("./assets/banner1.png") no-repeat center;*/
  background-size: 100% 100%;
}
@media (max-width: 950px) {
  #app {
    min-height: 276px;
    min-width: 100%!important;
  }
}
::-webkit-scrollbar {
  width: 0 !important;
}
/*.rules {*/
/*  -moz-user-select: none;*/
/*  -webkit-user-select: none;*/
/*  -ms-user-select: none;*/
/*  -khtml-user-select: none;*/
/*  user-select: none;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue